export const ROLES = {
  ADMIN: "Admin",
  SUPERVISOR: "Supervisor",
  TEACHER: "Teacher",
};
